import React from 'react';

export const GstIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" stroke="currentColor">
    <text x="35" y="70" fontSize="55" fontWeight="900" fontFamily="sans-serif" fill="#F5B800" stroke="none">G</text>
    <text x="75" y="65" fontSize="22" fontWeight="900" fontFamily="sans-serif" fill="currentColor" stroke="none">ST</text>
  </svg>
);

export const LoanIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="currentColor">
    <path d="M50 15 C30 35 20 50 20 65 A30 30 0 0 0 80 65 C80 50 70 35 50 15 Z" />
    <text x="50" y="75" fontSize="40" fontWeight="bold" fill="#F5B800" textAnchor="middle">$</text>
  </svg>
);

export const GovtProofIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none">
    <path d="M25 10 h35 l20 20 v60 h-55 z" stroke="currentColor" strokeWidth="6" strokeLinejoin="round"/>
    <path d="M60 10 v20 h20" stroke="currentColor" strokeWidth="6" strokeLinejoin="round"/>
    <line x1="35" y1="40" x2="65" y2="40" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
    <line x1="35" y1="55" x2="65" y2="55" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
    <line x1="35" y1="70" x2="50" y2="70" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
    <circle cx="70" cy="70" r="15" stroke="#F5B800" strokeWidth="6"/>
    <path d="M65 70 l4 4 l8 -8" stroke="#F5B800" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const TaxIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none">
    <path d="M20 30 l30 -15 l30 15 v15 l-30 15 l-30 -15 z" stroke="currentColor" strokeWidth="5" strokeLinejoin="round"/>
    <path d="M20 50 l30 15 l30 -15" stroke="currentColor" strokeWidth="5" strokeLinejoin="round"/>
    <path d="M20 70 l30 15 l30 -15" stroke="currentColor" strokeWidth="5" strokeLinejoin="round"/>
    <text x="50" y="47" fontSize="20" fontWeight="bold" fill="#F5B800" textAnchor="middle">TAX</text>
  </svg>
);

export const SchemeIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="currentColor">
    <circle cx="50" cy="50" r="40" fill="none" stroke="#F5B800" strokeWidth="6"/>
    <path d="M30 65 c10 10 30 10 40 0" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
    <path d="M50 25 v40" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
    <path d="M50 45 c-10 -5 -15 -15 -15 -15 s10 0 15 15" fill="currentColor"/>
    <path d="M50 35 c10 -5 15 -15 15 -15 s-10 0 -15 15" fill="currentColor"/>
    <path d="M20 50 l15 10" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
    <path d="M80 50 l-15 10" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
  </svg>
);

export const DocProofIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none">
    <path d="M20 10 h40 l20 20 v60 h-60 z" stroke="currentColor" strokeWidth="6" strokeLinejoin="round"/>
    <circle cx="50" cy="50" r="18" stroke="#F5B800" strokeWidth="6"/>
    <text x="50" y="55" fontSize="12" fontWeight="bold" fill="#F5B800" textAnchor="middle">CERTIFIED</text>
    <path d="M40 68 l-5 15 l15 -5 l15 5 l-5 -15" stroke="currentColor" strokeWidth="4" strokeLinejoin="round"/>
  </svg>
);

export const PropertyIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="currentColor">
    <path d="M50 15 L15 45 v40 h70 v-40 z" fill="currentColor"/>
    <path d="M40 85 v-30 h20 v30" fill="#F5B800"/>
    <path d="M25 40 v-15 h10 v6" fill="currentColor" stroke="#fff" strokeWidth="4"/>
  </svg>
);

export const InsuranceIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none">
    <path d="M50 15 L20 25 v30 c0 20 15 35 30 40 c15 -5 30 -20 30 -40 v-30 z" stroke="currentColor" strokeWidth="8" strokeLinejoin="round"/>
    <path d="M35 50 l10 10 l25 -25" stroke="#F5B800" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const RtoIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none">
    <path d="M40 10 h30 v50 h-30 z" stroke="currentColor" strokeWidth="5"/>
    <line x1="45" y1="20" x2="65" y2="20" stroke="currentColor" strokeWidth="4"/>
    <line x1="45" y1="30" x2="65" y2="30" stroke="currentColor" strokeWidth="4"/>
    <path d="M15 65 l5 -15 h30 l5 15" stroke="currentColor" strokeWidth="6" strokeLinejoin="round"/>
    <path d="M10 65 h40 v15 h-40 z" fill="currentColor"/>
    <circle cx="20" cy="80" r="8" fill="#F5B800" stroke="currentColor" strokeWidth="4"/>
    <circle cx="40" cy="80" r="8" fill="#F5B800" stroke="currentColor" strokeWidth="4"/>
  </svg>
);

export const RegistrationIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none">
    <path d="M25 65 v-20 c0 -10 15 -10 15 -10 s15 0 15 10 v20" stroke="currentColor" strokeWidth="6"/>
    <circle cx="40" cy="20" r="10" fill="currentColor" stroke="currentColor" strokeWidth="6"/>
    <path d="M10 65 h80" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
    <path d="M30 65 v25 M50 65 v25" stroke="currentColor" strokeWidth="6"/>
    <path d="M70 45 l-10 20 M70 45 l10 20" stroke="currentColor" strokeWidth="6" strokeLinecap="round"/>
    <circle cx="70" cy="30" r="8" fill="#F5B800" stroke="none"/>
  </svg>
);

export const MunicipalIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none">
    <path d="M20 90 v-50 h15 v-20 h30 v20 h15 v50 z" stroke="currentColor" strokeWidth="6" strokeLinejoin="round"/>
    <path d="M40 20 h20 M25 40 h10 M65 40 h10 M25 60 h10 M65 60 h10" stroke="#F5B800" strokeWidth="6"/>
    <path d="M40 90 v-20 h20 v20" stroke="currentColor" strokeWidth="6"/>
  </svg>
);

export const LegalIcon = ({ className }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none">
    <path d="M50 15 v70" stroke="currentColor" strokeWidth="6"/>
    <path d="M20 30 h60" stroke="#F5B800" strokeWidth="6" strokeLinecap="round"/>
    <path d="M20 30 l-10 30 h20 z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round"/>
    <path d="M80 30 l-10 30 h20 z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round"/>
    <path d="M40 85 h20" stroke="currentColor" strokeWidth="8" strokeLinecap="round"/>
  </svg>
);